import { WalletTransaction } from '@/src/types/wallet'

/**
 * Maps raw Flyin API transaction to internal transaction structure.
 */
export const mapRawTransaction = (raw: any): WalletTransaction => {
    let normalizedStatus: 'active' | 'inactive' | undefined
    if (raw.status) {
        const statusLower = String(raw.status).toLowerCase().trim()
        if (statusLower === 'active') {
            normalizedStatus = 'active'
        } else if (statusLower === 'in active' || statusLower === 'inactive') {
            normalizedStatus = 'inactive'
        }
    }

    const transactionId = raw.txnId ?? ''
    const referenceNumber = raw.refernceNumber ?? raw.referenceNumber
    const txnWalletAmt = raw.txnWalletAmt ?? 0
    const txnExpireDate = raw.txnExpireDate
    const createdAt = raw.txnDate ?? raw.createdAt
    const sourceType = raw.sourceType ?? ''

    return {
        transactionId,
        sourceType,
        referenceNumber: referenceNumber ?? undefined,
        txnWalletAmt: Number(txnWalletAmt) || 0,
        currency: raw.currency ?? '',
        txnExpireDate: txnExpireDate || undefined,
        status: normalizedStatus,
        createdAt: createdAt || undefined,
        txnType: raw.txnType ?? undefined
    }
}

/**
 * Maps raw Cleartrip API transaction to internal transaction structure.
 * Cleartrip transactions have a different schema with hyphenated keys:
 * { id, date, trip-details, trip-ref, event, txn-type, amount, currency, balance, status, expiry-date, caller-id }
 */
export const mapCleartripRawTransaction = (raw: any): WalletTransaction => {
    return {
        transactionId: String(raw.id ?? ''),
        sourceType: raw.event ?? '',
        referenceNumber: raw['trip-ref'] || undefined,
        txnWalletAmt: Number(raw.amount) || 0,
        currency: raw.currency ?? '',
        txnExpireDate: raw['expiry-date'] || undefined,
        createdAt: raw.date || undefined,
        // Cleartrip-specific fields
        tripDetails: raw['trip-details'] ?? undefined,
        txnType: raw['txn-type'] ?? undefined,
        walletType: raw.walletType ?? undefined,
        event: raw.event ?? undefined
    }
}

/**
 * Compute Cleartrip totalRecords using row-based offset and remaining count header.
 */
export const getCleartripTotalRecords = ({
    offset,
    size,
    pageCount,
    remainingCount
}: {
    offset: number
    size: number
    pageCount: number
    remainingCount: number
}): number => {
    const rowOffset = (offset - 1) * size + 1
    const totalRecords = rowOffset + pageCount + remainingCount - 1
    return Math.max(totalRecords, 0)
}
